var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 2,
    viewBox: "0 0 2 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.993197 0C1.28345 0 1.51927 0.090703 1.70068 0.272109C1.89116 0.453515 1.98639 0.698413 1.98639 1.0068C1.98639 1.32426 1.89116 1.56916 1.70068 1.7415C1.51927 1.91383 1.28345 2 0.993197 2C0.702948 2 0.462585 1.91383 0.272109 1.7415C0.0907029 1.56916 0 1.32426 0 1.0068C0 0.698413 0.0907029 0.453515 0.272109 0.272109C0.462585 0.090703 0.702948 0 0.993197 0Z",
    fill: "#1E304A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotDivider);
export default __webpack_public_path__ + "static/media/dot_divider.f0568a1d8a1450a89712946271799384.svg";
export { ForwardRef as ReactComponent };